import React from 'react';
import SalesDocumentList from '@/pages/SalesDocuments/SalesDocumentList';
import { PROFORMA_INVOICE } from '@/pages/SalesDocuments/documentTypes';

export default function ProformaInvoicesPage() {
  return <SalesDocumentList docType={PROFORMA_INVOICE} />;
}
